export enum AVATAR_SIZES {
    likes = 'likes',
    smallProfile = 'smallProfile'
}

export const FIXED_AVATAR_SIZE = true;

const LIKES_SIZES = { w220: 'w220', w240: 'w240', w300: 'w300', w480: 'w480', qvga: 'qvga', fhd: 'fhd',};

const SMALL_PROFILE = { w220: 'w220', w240: 'w240', w300: 'w300', w480: 'w480', qvga: 'qvga', fhd: 'fhd',};

const SIZES = { likes: LIKES_SIZES, smallProfile: SMALL_PROFILE };

export const getAvatarSizes = (type: AVATAR_SIZES) => SIZES[type];export enum AVATAR_SIZES {
    likes = 'likes',
    smallProfile = 'smallProfile'
}

export const FIXED_AVATAR_SIZE = true;

const LIKES_SIZES = { w220: 'w220', w240: 'w240', w300: 'w300', w480: 'w480', qvga: 'qvga', fhd: 'fhd',};

const SMALL_PROFILE = { w220: 'w220', w240: 'w240', w300: 'w300', w480: 'w480', qvga: 'qvga', fhd: 'fhd',};

const SIZES = { likes: LIKES_SIZES, smallProfile: SMALL_PROFILE };

export const getAvatarSizes = (type: AVATAR_SIZES) => SIZES[type];